import React from 'react';
import { withRouter } from 'react-router-dom';
import MaterialTable from 'material-table';
import { Space, Switch } from 'antd';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
// import "./discounts.css"
import tableIcons from '../common/Table/tableIcons';
import Button from '../common/Button';
import tableConfig from './config';
import { AddUpdateDiscountModal } from './AddUpdateDiscountModal';
import { useDiscountHook } from '../../hooks/discounts';
import { DeleteDiscountModal } from './DeleteDiscountModal';

const Discounts = (props) => {
   const {
      tableKey,
      paginationData,
      isLoading,
      discountList,
      // appVersions,
      // appVersionStatusUpdateData,
      showAddDiscountModal,
      showDeleteDiscountModal,
      // handleAppVersionStatusChange,
      onPageChange,
      // onFilterChange,
      getDiscountList,
      isEdit,
      deleteDiscountEditData,
      handleDeleteDiscount,
      deleteDiscountData,
      handleDiscountSubmit,
      toggleAddDiscountModal,
      toggleDeleteDiscountModal
   } = useDiscountHook()
   const config = tableConfig(props)

   // config.columns[3].render = (rowData) => {
   //    const appVersionIndex = rowData.tableData.id

   //    return <div><Switch
   //       // // // loading={appVersionStatusUpdateData.appVersionIndex > -1 && appVersionStatusUpdateData.appVersionIndex === appVersionIndex && appVersionStatusUpdateData.isLoading}
   //       checked={rowData.required === "true" || rowData.required === true || false}
   //       onChange={(isChecked) => handleAppVersionStatusChange(isChecked, appVersionIndex, rowData)} /></div >
   // }

   let actions = [
      {
         icon: () => <EditOutlinedIcon color="secondary" fontSize="small" />,
         tooltip: 'Edit',
         onClick: (event, rowData) => toggleAddDiscountModal(rowData, true)
      }, {
         icon: () => <DeleteOutlineIcon color="secondary" fontSize="small" />,
         tooltip: 'Delete',
         onClick: (event, rowData) => {
            return (toggleDeleteDiscountModal(rowData))
         }
      }
   ];
   console.log(paginationData, "::paginationData")
   return (
      <div>
         <div className='app-versions-page-wraper'>
            <div className='app-version-button-wrap'>
               <Space direction="vertical" size={12}>
                  <Button size="small" label="Add Discounts" className="add-app-version-button" onClick={toggleAddDiscountModal} />
               </Space>
            </div>
         </div>
         <div className={`app-versions-table-wrapper`}>
            <MaterialTable
               style={{
                  width: '100%',
                  boxShadow: 'none',
                  background: 'white',
                  padding: '15px',
                  borderRadius: '5px'
               }}
               key={tableKey}
               icons={tableIcons}
               actions={actions}
               columns={config.columns || []}
               data={discountList.discounts ? [...discountList.discounts] : []}
               title={"discount"}
               isLoading={isLoading || false}
               totalCount={paginationData.total}
               page={paginationData.page}
               onChangePage={onPageChange}
               onFilterChange={(event) => {
                  // onFilterChange(event)
               }}
               options={{
                  toolbar: false,
                  filtering: false,
                  sorting: false,
                  hideFilterIcons: true,
                  actionsColumnIndex: -1,
                  tableLayout: 'fixed',
                  searchFieldAlignment: 'left',
                  pageSize: paginationData.limit,
                  total: paginationData.total,
                  paginationType: 'stepped',
                  pageSizeOptions: [10, 20, 30, 50, 100],
                  paging: true,
                  search: false,
                  maxBodyHeight: 'auto', // Automatically adjust body height
                  rowStyle: {
                     height: "10px", // Set row height to auto
                  },
                  headerStyle: {
                     backgroundColor: '#f58634',
                     color: 'white',
                     padding: '8px 0 8px 16px',
                     textAlign: 'start'
                  },
                  filterCellStyle: {
                     backgroundColor: '#fef3ea',
                     padding: '8px 0 8px 16px',
                  },
                  searchFieldStyle: {
                     borderRadius: '20px',
                     border: '1px solid grey',
                     padding: '5px 35px',
                     marginBottom: '10px',
                     display: 'none',
                  },
               }}
            />
         </div>
         <AddUpdateDiscountModal
            getDiscountList={getDiscountList}
            deleteDiscountEditData={deleteDiscountEditData}
            showAddDiscountModal={showAddDiscountModal}
            isEdit={isEdit}
            handleSubmit={handleDiscountSubmit}
            toggleAddDiscountModal={toggleAddDiscountModal}
         />

         <DeleteDiscountModal
            // selectedAppVersionData={selectedAppVersionData}
            deleteDiscountData={deleteDiscountData}
            isModalOpen={showDeleteDiscountModal}
            handleSubmit={handleDeleteDiscount}
            handleCloseModal={toggleDeleteDiscountModal}
         />
      </div>
   )
};

export default withRouter(Discounts);
